import { ArcElement, Chart, ChartMeta, Color } from 'chart.js'
import _ from 'lodash'

const afterDatasetDrawPiChart = (
  chart: Chart,
  args: { index: number; meta: ChartMeta },
  options: any
) => {
  // Get the Ctx from the current chart
  const ctx = chart.ctx
  //ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontFamily, 'normal', Chart.defaults.global.defaultFontFamily);
  ctx.textAlign = 'center'
  ctx.textBaseline = 'bottom'

  _.forEach(chart.data.datasets, (dataset, index) => {
    const metadata = chart.getDatasetMeta(index)
    _.forEach(metadata.data, (arcElement, index) => {
      const arc = arcElement as Partial<ArcElement>
      if (isValidArcElement(arc)) {
        const middleAngle = (arc.startAngle + arc.endAngle) / 2
        const radius = (arc.innerRadius + arc.outerRadius) / 2
        const data = dataset.data
        const value = data[index]
        if (isNumberArray(data) && typeof value === 'number') {
          const total = data.reduce((sum, val) => {
            return sum + val
          }, 0)
          const percentage =
            value > 0 && total > 0
              ? ((value / total) * 100).toFixed(1) + '%'
              : null
          if (percentage) {
            const x = chart.width / 2 + radius * Math.cos(middleAngle)
            const y = chart.height / 2 + radius * Math.sin(middleAngle)
            ctx.fillStyle = getTextColorFromBackground(
              arc.options.backgroundColor
            )
            ctx.font = '20px Arial'
            ctx.fillText(percentage, x, y)
          }
        }
      }
    })
  })
}

const isNumberArray = (value: unknown): value is Array<number> => {
  return Array.isArray(value) && value.every((item) => typeof item === 'number')
}

const isValidArcElement = (
  value: unknown
): value is Required<
  Pick<
    ArcElement,
    'startAngle' | 'endAngle' | 'innerRadius' | 'outerRadius' | 'options'
  >
> => {
  return !!(
    value &&
    typeof value === 'object' &&
    'startAngle' in value &&
    value.startAngle !== undefined &&
    'endAngle' in value &&
    value.endAngle !== undefined &&
    'innerRadius' in value &&
    value.innerRadius !== undefined &&
    'outerRadius' in value &&
    value.outerRadius !== undefined &&
    'options' in value &&
    value.options != undefined
  )
}

function getTextColorFromBackground(color: Color): string {
  let hex = ''
  if (typeof color === 'string') {
    hex = color
  }
  if (!/^#([0-9A-Fa-f]{3}){1,2}$/.test(hex)) {
    return 'black'
  }
  let r: number, g: number, b: number
  if (hex.length === 4) {
    // Format court (#RGB)
    r = parseInt(hex[1] + hex[1], 16)
    g = parseInt(hex[2] + hex[2], 16)
    b = parseInt(hex[3] + hex[3], 16)
  } else {
    // Format long (#RRGGBB)
    r = parseInt(hex.slice(1, 3), 16)
    g = parseInt(hex.slice(3, 5), 16)
    b = parseInt(hex.slice(5, 7), 16)
  }

  const brightness = 0.299 * r + 0.587 * g + 0.114 * b
  return brightness > 128 ? 'black' : 'white'
}

export { afterDatasetDrawPiChart }
